module.exports = __webpack_public_path__ + "static/img/Nathaniel-Sulzberger.5ad83d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nathaniel-Sulzberger.jpg
// module id = Lbmj
// module chunks = 0